import styled from 'styled-components';
import { Spin } from 'antd';

export const WrapperContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const TableContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const ScrollContainer = styled.div`
  overflow-y: auto;
  height: 100%;
  width: 100%;
  flex: 1;
`;

export const CustomSpin = styled(Spin)`
  .ant-spin-dot-item {
    animation-duration: 150ms !important; /* Entire cycle duration */
  }

  .ant-spin-dot-item:nth-child(1) {
    animation-delay: 0ms !important;
  }

  .ant-spin-dot-item:nth-child(2) {
    animation-delay: 37.5ms !important;
  }

  .ant-spin-dot-item:nth-child(3) {
    animation-delay: 75ms !important;
  }

  .ant-spin-dot-item:nth-child(4) {
    animation-delay: 112.5ms !important;
  }
`;
